import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export function useReadOnly() {
  const route = useRoute();
  const store = useStore();

  const isReadOnly = computed(() => {
    const readOnlyQuery = route.query?.readonly ?? route.query?.readOnly;
    const isReadOnlyQuery =
      typeof readOnlyQuery === 'string' && readOnlyQuery.toLowerCase() === 'true';

    const readOnlyFromStore = store.getters['scoreSet/isReadOnly'];

    return readOnlyFromStore || isReadOnlyQuery;
  });

  return { isReadOnly };
}
